import moment from 'moment';

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'KES',
  minimumFractionDigits: 0,
});

const currencyFormatter = (currency) => formatter.format(Math.round(currency));

const formatLongDate = (date) => moment(date).format('DD, MMMM YYYY');

const formatDate = (date) => moment(date).format('DD, MMM YYYY');

const getDateDiff = (startDate, endDate) => {
  const diffInMs = new Date(endDate) - new Date(startDate);
  return (diffInMs / (1000 * 60 * 60 * 24));
};

const isDateOverdue = (timestamp) => {
  const todayMoment = moment(new Date());
  const today = todayMoment.format('YYYY-MM-DD');

  const currentTime = new Date(today).getTime();
  const dueTime = new Date(correctDate(timestamp)).getTime();

  return currentTime > dueTime;
};

const correctDate = (timestamp) => {
  if (timestamp !== undefined) {
    const splitted = timestamp.toString().split('-');

    if (splitted[1] && splitted[1].length === 1) {
      splitted[1] = `0${splitted[1]}`;
    }

    if (splitted[2] && splitted[2].length === 1) {
      splitted[2] = `0${splitted[2]}`;
    }

    return splitted.join('-');
  }
  return timestamp;
};

const creditPolicyURL = 'https://rewotciro.co.ke/credit-Terms-and-Conditions';

/**
 * Format a number
 * @param {Number} value
 */
const formatNumber = (value) => {
  let num = value;
  if (value > 999999) {
    num = `${roundedToFixed(value / 1000000, 1)}M`;
  } else if (value > 999) {
    num = `${roundedToFixed(value / 1000, 1)}K`;
  } else {
    num = value;
  }

  return num;
};

const roundedToFixed = (input, digits) => {
  const rounder = 10 ** digits;
  return (Math.round(input * rounder) / rounder).toFixed(digits);
};

const isSessionExpired = (expiredTime) => {
  const current = moment(new Date()).unix;
  const expire = moment(expiredTime).unix;

  return current > expire;
};

export {
  currencyFormatter,
  formatLongDate,
  getDateDiff,
  isDateOverdue,
  creditPolicyURL,
  formatNumber,
  roundedToFixed,
  formatDate,
  isSessionExpired,
};
